export const matchesCriteria = (criteriaValue, value, inverseCriteria = false) => {
    const isMatched = typeof criteriaValue === 'string'
        ? criteriaValue
            .split(',')
            .map((val) => val.trim())
            .includes(String(value))
        : criteriaValue === value;
    return inverseCriteria ? !isMatched : isMatched;
};
